module.exports = __webpack_public_path__ + "img/shopee-logo.212f4274.png";